<template>
    <div class="wrap">
        <div class="box" @click="consociation">
            <i class="ico ico-icon_108"></i>
            <span>商务合作</span>
        </div>
        <div class="box" @click="enter">
            <i class="ico ico-icon_107"></i>
            <span>入驻枫车养车</span>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex'
import { Dialog } from 'vant'

export default {
    name: 'OfficialBar',
    components: {
        [Dialog.name]: Dialog
    },
    computed: {
        ...mapState({
            isWeixin: ({ appInfo }) => appInfo.isWeixin,
        }),
    },
    methods: {
        consociation () {
            // this.show = true
            window.open('tel:4008481615', '_blank')
        },
        enter () {
            // 商家入驻
            const enterObj = {
                alpha: 'http://192.168.1.206/h5/iCar/openMiniSstore/index.html',
                beta: 'https://test-h5.carisok.com/iCar/openMiniSstore/index.html',
                abtest: 'https://abtest-h5.carisok.com/iCar/openMiniSstore/index.html',
                release: 'https://h5.carisok.com/iCar/openMiniSstore/index.html'
            }
            window.location.href = this.isWeixin
                ? enterObj[GLOBAL_API_ENV]
                // 加入枫车
                : 'https://www.carisok.net/join.html'
        },
    },
}
</script>
<style lang="stylus" scoped>
@import '~@/assets/stylus/variables.styl'
@import '~@/assets/stylus/mixin.styl'
    .wrap
        display flex
        // width 100%
        height 74px
        padding 12px 30px
        .box
            background-color $fcWhite
            display flex
            align-items center
            justify-content center
            flex 1
            height 100%
            border-radius 50px
            &:nth-child(1)
                margin-right 15px
            &:nth-child(2)
                margin-left 15px
            span
                padding-left 20px
                font-size $fontBase
                color $black333
</style>
